import { CommonModule } from '@angular/common';
import { Component, input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ProductListCardComponent } from "src/app/components/product-list-card/product-list-card.component";
import { ProductListingHit } from '../../models/product-listing.model';

@Component({
  standalone: true,
  selector: 'webstore-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss'],
  imports: [CommonModule, RouterModule, ProductListCardComponent]
})
export class ProductsComponent {



  readonly productsInput = input<ProductListingHit[]>([]);

  // Public getter for template access
  readonly productsSignal = this.productsInput;

}

